import type { Emitter } from 'mitt';
import mitt, { EventType } from "mitt";

interface Events extends Record<EventType, unknown> {
  "editor:resize-screen": string,
  "store:add-snippet-finish": { id: string, key: string },
  WithoutPresetEdited: string;
  CallBackWithoutPresetEdited: string;
  tryNowOnboarding: undefined;
  googleFontsLoaded: undefined;
  'show:click': any;
  'hide:click': any;
  'show:hover': any;
  'hide:hover': any;
  hide: any;
  'gem-meter:remove-element': string;
}

const emitter: Emitter<Events> = mitt<Events>();
export default emitter;
